module.exports = __webpack_public_path__ + "static/media/ins2.6a45a37c.jpg";